import { useGetUserAccessibleOrgsByParamsQuery as _useGetUserAccessibleOrgsByParamsQuery, useGetUserAccessibleOrgsQuery as _useGetUserAccessibleOrgsQuery, useSwitchOrgMutation as _useSwitchOrgMutation, } from "../generated/graphql-types";
export const useSwitchOrgMutation = (onComplete, onError, orgId) => _useSwitchOrgMutation({
    variables: {
        orgId,
    },
    update: (cache, result) => {
        onComplete(result?.data.Session__switchOrg);
    },
    onError: (error) => {
        onError(error);
    },
});
export const useGetUserAccessibleOrgsQuery = () => {
    const { data, error, loading, refetch } = _useGetUserAccessibleOrgsQuery();
    return {
        error,
        loading,
        data: data?.getUserAccessibleOrgs,
        refetch,
    };
};
export const useGetUserAccessibleOrgsByParamsQuery = (inputData) => {
    const { data, error, loading, refetch, } = _useGetUserAccessibleOrgsByParamsQuery({
        fetchPolicy: 'no-cache',
        variables: {
            inputData,
        },
    });
    return {
        error,
        loading,
        data: data?.getUserAccessibleOrgsByParams,
        refetch,
    };
};
//# sourceMappingURL=orgs-service.js.map